import cloneDeep from 'clone-deep';
import CryptoJS from 'crypto-js'
import axios from 'axios'
import * as conf from "@/store/conf";
import JSEncrypt from 'jsencrypt'
import {publicKey} from '@/store/public'
const encryptor = new JSEncrypt()

// 支持多层级嵌套
export function setPrintArrayContentChild(headDetail, list, max = 1, style) {
	let layout;
	let headList;
	if (Array.isArray(headDetail) === true) {
		headList = headDetail
		layout = headDetail.map(item => {
			return {
				style: item.style,
				text: item.text,
				render: item.render,
				children: item.children
			}
		})
	} else {
		headList = headDetail.children;
		layout = {
			...headDetail,
			children: headList.map(item => {
				return {
					style: item.style,
					text: item.text,
					render: item.render,
					children: item.children
				}
			})
		}
	}
	let copyEmpty = headList.map(item => {
		return {
			text: '',
			style: item.itemStyle ? item.itemStyle : item.style,
		}
	})
	let itemList = list.map(item => {
		return {
			children: headList.map(inner => {
				return {
					text: inner.format ? inner.format(item) : item[inner.propsName],
					style: inner.itemStyle ? inner.itemStyle : inner.style,
				}
			})
		}
	})
	if (itemList.length > max) {
		itemList.splice(max, itemList.length - max)
	} else {
		for (let i = itemList.length; i < max; i++) {
			itemList.push({
				children: copyEmpty
			})
		}
	}
	console.log(layout)
	if (Array.isArray(layout)) {
		return [{
			children: layout
		}].concat(itemList)
	} else {
		return [{
			...layout
		}].concat(itemList)
	}
}

// 单层级嵌套 支持传入 对象 改变父节点样式
export function setPrintArrayContent(headDetail, list, max = 1, exStyle) {
	let layout;
	let headList;
	if (Array.isArray(headDetail) === true) {
		headList = headDetail
		layout = headDetail.map(item => {
			return {
				textStyle: item.textStyle,
				style: item.style,
				text: item.text,
				render: item.render
			}
		})
	} else {
		headList = headDetail.children;
		layout = {
			...headDetail,
			children: headList.map(item => {
				return {
					textStyle: item.textStyle,
					style: item.style,
					text: item.text,
					render: item.render
				}
			})
		}
	}
	let copyEmpty = headList.map(item => {
		return {
			text: '',
			style: item.itemStyle ? item.itemStyle : item.style,
		}
	})
	let itemList = list.map(item => {
		return {
			children: headList.map(inner => {
				return {
					text: inner.format ? inner.format(item) : item[inner.propsName],
					style: inner.itemStyle ? inner.itemStyle : inner.style,
					textStyle: inner.textStyle
				}
			})
		}
	})
	if (itemList.length > max) {
		itemList.splice(max, itemList.length - max)
	} else {
		for (let i = itemList.length; i < max; i++) {
			itemList.push({
				children: copyEmpty
			})
		}
	}
	if (Array.isArray(layout)) {
		return [{
			children: layout
		}].concat(itemList)
	} else {
		return [{
			...layout
		}].concat(itemList)
	}

}
// 设置数据最大长度 复制空数据结构
export function setPrintArray(array, max, copyArray) {
	if (array.length >= max) {
		return array.splice(0, max);
	} else {
		while (array.length < max) {
			array.push(JSON.parse(JSON.stringify(copyArray)));
		}
		return array;
	}
}

export function selectOptionsFormat(item) {
	return {
		label: item.code,
		value: item.code
	};
}
export const tableMerge = function (columnInfo, list) {
	return list.map(item => tableMergeColumn(columnInfo, item))
}
export const tableMergeColumn = function (columnInfo, info) {

	return setChildren(columnInfo)

	function setChildren(column) {
		if (Array.isArray(column) === true) {
			return column.map(item => mergeProps(item))
		} else {
			return mergeProps(column)
		}
	}
	function mergeProps(column) {
		if (column.children && column.children.length > 0) {
			return {
				...column,
				children: setChildren(column.children)
			}
		} else {
			if (column.propsName) {
				return {
					...column,
					text: info[column.propsName]
				}
			} else {
				return column
			}
		}
	}
}

export const changeToObject = function (array, key) {
	var obj = array.reduce(function (o, v, i) {
		o[v[key]] = v;
		return o;
	}, {});
	return obj;
};
export const routerNewWindow = function (path) {
	window.open(`${window.location.origin}/${path}`)
}
export const JsonDeepCopy = function (params) {
	return cloneDeep(params);
}
// 绑定函数 或者 数组里面的bind
export const bindParams = function (params, that) {
	// console.log(params, that)
	if (!params) return params;
	if (isArray(params)) {
		return params.map(setParams)
	} else {
		return setParams(params)
	}

	function setParams(params) {
		if (typeof params === 'number' || typeof params === 'string') return params;
		const keys = {};
		Object.keys(params).forEach(inner => {
			if (isArray(params[inner])) {
				keys[inner] = bindParams(params[inner], that);
			} else if (typeof params[inner] === 'object') {
				keys[inner] = bindParams(params[inner], that);
			} else if (typeof params[inner] === 'function') {
				keys[inner] = params[inner].bind(that);
			} else {
				keys[inner] = params[inner];
			}
		})
		return keys;
	}
}

export const strlen = function (str) {
	var len = 0;
	for (var i = 0; i < str.length; i++) {
		var c = str.charCodeAt(i);
		//单字节加1
		if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
			len++;
		}
		else {
			len += 2;
		}
	}
	return len;
}
// 返回新数据
export const setParamsInfo = function (options, params) {
	const _params = params || {};
	const _options = JsonDeepCopy(options);
	if (!_params) return options;
	Object.keys(_params).forEach(item => {
		const index = _options.findIndex(inner => inner.propsName === item);
		if (index > -1) _options[index].value = _params[item];
	})
	return _options;
}
// 直接修改源数据
export const setParamsInfoEdit = function (options, params, propsName = 'propsName', valueName = 'value') {
	const _params = params || {};
	if (!_params) return options;
	Object.keys(_params).forEach(item => {
		const index = options.findIndex(inner => inner[propsName] === item);
		if (index > -1) options[index][valueName] = _params[item];
	})
	console.log(options)
}
// 直接修改原数据
export const setParamsInfoToObj = function (target, params) {
	Object.keys(params || {}).forEach(item => {
		target[item] = params[item]
	})
}

// 检查是否有位空
export const formatParamsRequire = function (options, keyName = 'isRequire') {
	return options.reduce((pre, next) => {
		const { value } = next;
		const isRequire = next[keyName];
		const isEmpty = value === '' || value === null || value === undefined;
		if (isRequire && isEmpty) pre = `${pre}${next.label}不能为空,`;
		return pre;
	}, '')
}

// 返回指定的对象
export const formatParams = function (options, keyName = 'propsName') {
	return options.reduce((pre, next) => {
		const key = next[keyName];
		if (!pre[key] && (next.value || next.value === 0)) {
			pre[key] = next.value;
		}
		return pre;
	}, {})
}
/**
 * 截取字符串 中英文混合
 * @param str	待处理字符串
 * @param len	截取字节长度 中文2字节 英文1字节
 */
export const subString = function (str, len) {
	var regexp = /[^\x00-\xff]/g;// 正在表达式匹配中文
	// 当字符串字节长度小于指定的字节长度时
	if (str.replace(regexp, "aa").length <= len) {
		return str;
	}
	// 假设指定长度内都是中文
	var m = Math.floor(len / 2);
	for (var i = m, j = str.length; i < j; i++) {
		// 当截取字符串字节长度满足指定的字节长度
		if (str.substring(0, i).replace(regexp, "aa").length >= len) {
			return str.substring(0, i);
		}
	}
	return str;
}

export const isNumber = function (obj) {
	if (obj === '' || obj === null || obj === undefined) return false;
	var reg = /^[0-9]+.?[0-9]*$/;
	if (reg.test(Math.abs(obj))) {
		return true;
	}
	return false;
}
export const isArray = function (arg) {
	if (typeof arg === 'object') {
		return Object.prototype.toString.call(arg) === '[object Array]';
	}
	return false;
}

export const isEmpty = function (obj) {
	if (typeof obj == "undefined" || obj == null || obj == "") {
		return true;
	} else {
		return false;
	}
}

// 四舍五入
export const toFixed = function (val, number = 2) {
	if (!isNumber(val)) return 0;
	const num = Math.pow(10, number);
	return Math.round(val * num) / num;
}

// 四舍五入，保留小数点后number位
export const twoDecimal = function (val, number = 2) {
	if (!isNumber(val)) return 0.00;
	const num = Math.pow(10, number);
	var result = parseFloat(val);
	result = Math.round(val * num) / num;
	var s_x = result.toString();
	var pos_decimal = s_x.indexOf('.');
	if (pos_decimal < 0) {
		pos_decimal = s_x.length;
		s_x += '.';
	}
	while (s_x.length <= pos_decimal + number) {
		s_x += '0';
	}
	return s_x;
}


export const ArrayDistinct = function (array, key) {
	var result = [], hash = {};
	for (var i = 0; i < array.length; i++) {
		var elem = array[i][key];
		if (!hash[elem]) {
			result.push(array[i]);
			hash[elem] = true;
		}
	}
	return result;
}
export const changeToObjectByKeys = function (array, keysArray) {
	var obj = array.reduce(function (o, v, i) {
		var key = '';
		for (var i in keysArray) {
			key = key + v[keysArray[i]];
		}
		o[key] = v;
		return o;
	}, {});
	return obj;
};

export const getNowFormatDate = function () {
	var date = new Date();
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
};

export const splitBatches = function (progressList) {
	return progressList.reduce(function (o, v, i) {
		if (o.hasOwnProperty(v.parentBatchNo)) {
			o[v.parentBatchNo].list.push(v);
		} else {
			o[v.parentBatchNo] = {};
			o[v.parentBatchNo].list = [v];
			o[v.parentBatchNo].parentComments = v.parentComments;
			o[v.parentBatchNo].parentPnodeName = v.parentPnodeName;
			o[v.parentBatchNo].parentBusinessCode2Desc = v.parentBusinessCode2Desc;
		}
		return o;
	}, {});
}


export const GetFileNameNoExt = function (filepath) {
	var pos = filepath.lastIndexOf("\.");
	return filepath.substring(0, pos);//文件名
}

export const md5 = hex_md5;

export const dateFormat = function (date, separator = '-') {
	//日期格式化yyyy-MM-dd
	var month = date.getMonth() + 1;
	var day = date.getDate();
	month = (month.toString().length == 1) ? ("0" + month) : month;
	day = (day.toString().length == 1) ? ("0" + day) : day;

	var result = date.getFullYear() + `${separator}` + month + `${separator}` + day;

	return result;
}

/**
 * 格式化时间
 * @author  caoweizheng
 * @param  {time} 时间
 * @param  {cFormat} 格式
 * @return {String} 字符串
 *
 * @example formatTime('2018-1-29', '{y}/{m}/{d} {h}:{i}:{s}') // -> 2018/01/29 00:00:00
 */
export const formatTime = function (t_cur, cFormat) {
	if (arguments.length === 0) return null
	if (!t_cur) return '';
	var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	var date;

	if (typeof time === 'object') {
		date = time
	} else {
		date = new Date(t_cur)
	}

	var formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		var value = formatObj[key]
		if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
};

/**
 * 对象属性设为空
 * @author  caoweizheng
 * @param  {obj} 对象参数
 * @return {Object} 对象字段设为空
 *
 * @example setEmptyObj({a: 1, b: 2}) // -> {a: null, b: null}
 */

/**
 * 对象属性设为空
 * @author  caoweizheng
 * @param  {params.file} Bolb
 * @param  {params.fileName} 文件名
 * @param  {params.type} 文件后缀
 *
 * @example
 */
export const fileDown = function ({ file, fileName = '报表下载', type = 'xls' }) {
	const content = file;
	const blob = new Blob([content])
	const name = `${fileName}.${type}`;
	if ('download' in document.createElement('a')) { // 非IE下载
		const elink = document.createElement('a')
		elink.download = name
		elink.style.display = 'none'
		elink.href = URL.createObjectURL(blob)
		document.body.appendChild(elink)
		elink.click()
		URL.revokeObjectURL(elink.href) // 释放URL 对象
		document.body.removeChild(elink)
	} else { // IE10+下载
		navigator.msSaveBlob(blob, name)
	}
}

export const setEmptyObj = function (obj) {
	return Object.keys(obj).reduce((pre, next) => {
		pre[next] = '';
		return pre;
	}, obj)
}


export const getCookie = function (key) {
	var arr, reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
	if (arr = document.cookie.match(reg))
		return unescape(arr[2]);
	else
		return null;
};

export const checkUpload = function (typeArrys, type) {
	if (Object.prototype.toString.call(typeArrys) != '[object Array]') return false;
	let result = false;
	typeArrys.forEach(function (item) {
		if (type == item.valueCode) {
			result = true;
		}
	});
	return result;
}

/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
var hexcase = 0;  /* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance   */
var chrsz = 8;  /* bits per input character. 8 - ASCII; 16 - Unicode      */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_md5(s) { return binl2hex(core_md5(str2binl(s), s.length * chrsz)); }
function b64_md5(s) { return binl2b64(core_md5(str2binl(s), s.length * chrsz)); }
function str_md5(s) { return binl2str(core_md5(str2binl(s), s.length * chrsz)); }
function hex_hmac_md5(key, data) { return binl2hex(core_hmac_md5(key, data)); }
function b64_hmac_md5(key, data) { return binl2b64(core_hmac_md5(key, data)); }
function str_hmac_md5(key, data) { return binl2str(core_hmac_md5(key, data)); }

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test() {
	return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len) {
	/* append padding */
	x[len >> 5] |= 0x80 << ((len) % 32);
	x[(((len + 64) >>> 9) << 4) + 14] = len;

	var a = 1732584193;
	var b = -271733879;
	var c = -1732584194;
	var d = 271733878;

	for (var i = 0; i < x.length; i += 16) {
		var olda = a;
		var oldb = b;
		var oldc = c;
		var oldd = d;

		a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
		d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
		c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
		b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
		a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
		d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
		c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
		b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
		a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
		d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
		c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
		b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
		a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
		d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
		c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
		b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

		a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
		d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
		c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
		b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
		a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
		d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
		c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
		b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
		a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
		d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
		c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
		b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
		a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
		d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
		c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
		b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

		a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
		d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
		c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
		b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
		a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
		d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
		c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
		b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
		a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
		d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
		c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
		b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
		a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
		d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
		c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
		b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

		a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
		d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
		c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
		b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
		a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
		d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
		c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
		b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
		a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
		d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
		c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
		b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
		a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
		d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
		c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
		b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

		a = safe_add(a, olda);
		b = safe_add(b, oldb);
		c = safe_add(c, oldc);
		d = safe_add(d, oldd);
	}
	return Array(a, b, c, d);

}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t) {
	return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}
function md5_ff(a, b, c, d, x, s, t) {
	return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t) {
	return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t) {
	return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t) {
	return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Calculate the HMAC-MD5, of a key and some data
 */
function core_hmac_md5(key, data) {
	var bkey = str2binl(key);
	if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);

	var ipad = Array(16), opad = Array(16);
	for (var i = 0; i < 16; i++) {
		ipad[i] = bkey[i] ^ 0x36363636;
		opad[i] = bkey[i] ^ 0x5C5C5C5C;
	}

	var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
	return core_md5(opad.concat(hash), 512 + 128);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y) {
	var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt) {
	return (num << cnt) | (num >>> (32 - cnt));
}

/*
 * Convert a string to an array of little-endian words
 * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
 */
function str2binl(str) {
	var bin = Array();
	var mask = (1 << chrsz) - 1;
	for (var i = 0; i < str.length * chrsz; i += chrsz)
		bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (i % 32);
	return bin;
}

/*
 * Convert an array of little-endian words to a string
 */
function binl2str(bin) {
	var str = "";
	var mask = (1 << chrsz) - 1;
	for (var i = 0; i < bin.length * 32; i += chrsz)
		str += String.fromCharCode((bin[i >> 5] >>> (i % 32)) & mask);
	return str;
}

/*
 * Convert an array of little-endian words to a hex string.
 */
function binl2hex(binarray) {
	var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
	var str = "";
	for (var i = 0; i < binarray.length * 4; i++) {
		str += hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8 + 4)) & 0xF) +
			hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8)) & 0xF);
	}
	return str;
}

/*
 * Convert an array of little-endian words to a base-64 string
 */
function binl2b64(binarray) {
	var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	var str = "";
	for (var i = 0; i < binarray.length * 4; i += 3) {
		var triplet = (((binarray[i >> 2] >> 8 * (i % 4)) & 0xFF) << 16)
			| (((binarray[i + 1 >> 2] >> 8 * ((i + 1) % 4)) & 0xFF) << 8)
			| ((binarray[i + 2 >> 2] >> 8 * ((i + 2) % 4)) & 0xFF);
		for (var j = 0; j < 4; j++) {
			if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;
			else str += tab.charAt((triplet >> 6 * (3 - j)) & 0x3F);
		}
	}
	return str;
}

export function groupByField(array, f) {
	const groups = {};
	array.forEach(function (o) { //注意这里必须是forEach 大写
		const group = JSON.stringify(f(o));
		groups[group] = groups[group] || [];
		groups[group].push(o);
	});
	return Object.keys(groups).map(function (group) {
		return groups[group];
	});
}  
/**
 *  保留小数
 * @param {数值} f 
 * @param {精确位数} digit 
 */
export function formatNum(f, digit = 2) { 
	var m = Math.pow(10, digit); 
	return parseInt(f * m, 10) / m; 
}

/**
 * @name: blobToDownLoad
 * @msg: 文件流转Blob下载
 * @param {*} res
 * @return {*}
 */
export function blobToDownLoad(res) {
	let url = window.URL.createObjectURL(res.data); //表示一个指定的file对象或Blob对象
	// console.log(url,"看一下这是啥")
	let a = document.createElement("a"); 
	document.body.appendChild(a);
	let fileName=res.headers["content-disposition"].split(";")[1].split("=")[1];  //filename名称从后端返回的headers截取
	// let fileName = params.objectName // 这里也可以这样获取到文件名
	a.href = url;
	a.download = fileName; //命名下载名称
	a.click(); //点击触发下载  
	window.URL.revokeObjectURL(url)
}
/**
 * @name: 
 * @msg: 转大写金额
 * @param {*} money
 * @return {*}
 */
export function convertCurrency(money) {
  let isNegative = false
  let _money = parseInt(money)
  if(_money < 0) {
	isNegative = true
  }
  money = Math.abs(money)
  //汉字的数字
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  //基本单位
  var cnIntRadice = new Array('', '拾', '佰', '仟');
  //对应整数部分扩展单位
  var cnIntUnits = new Array('', '万', '亿', '兆');
  //对应小数部分单位
  var cnDecUnits = new Array('角', '分', '毫', '厘');
  //整数金额时后面跟的字符
  var cnInteger = '整';
  //整型完以后的单位
  var cnIntLast = '元';
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  //金额整数部分
  var integerNum;
  //金额小数部分
  var decimalNum;
  //输出的中文金额字符串
  var chineseStr = '';
  //分离金额后用的数组，预定义
  var parts;

  if (money == '') { return ''; }

  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }

  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }

  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }

  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }

  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }

  return isNegative ? '负' + chineseStr : chineseStr;
}

export function getProvienceAndCityTextByCodeList(codeList = [], options = []) { 
	let text = ''
	if (options.length === 0) return text;
	if(codeList && codeList.length) {
			const provienceIndex = options.findIndex(item => item.value == codeList[0]);
			if (provienceIndex > -1) {
					text += options[provienceIndex].label;
			}
			if (codeList[1]) {
					const cityIndex = options[provienceIndex].children.findIndex(item => item.value == codeList[1]);
					if (cityIndex > -1) {
							text += options[provienceIndex].children[cityIndex].label;
					}
			} 
			return text
	}
}

export function encrypt(message) {
	encryptor.setPublicKey(publicKey) 
	return encryptor.encrypt(message)
}
	

// export function encrypt (message) {
// 	let key = CryptoJS.enc.Utf8.parse("999888abcd")
// 	let encryptData = CryptoJS.DES.encrypt(message, key,{
// 		mode: CryptoJS.mode.ECB,
// 		padding: CryptoJS.pad.Pkcs7
// 	})
// 	return encryptData.ciphertext.toString()
// }


export function groupBy(collection, iteratee) {
  return collection.reduce((result, item) => {
    const key = typeof iteratee === 'function' ? iteratee(item) : item[iteratee];

    if (!result[key]) {
      result[key] = [];
    }

    result[key].push(item);

    return result;
  }, {});
}

export function forIn(object, callback) {
  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      callback(object[key], key, object);
    }
  }
}

export function uniq(array) {
  const uniqueArray = [];
  for (const item of array) {
    if (!uniqueArray.includes(item)) {
      uniqueArray.push(item);
    }
  }
  return uniqueArray;
}

export function formatMultipleParams(paramsList, originParams) {
  let params = {}
  paramsList.forEach(item => {
    let match =
      originParams[item] && !(originParams[item] instanceof Array) ? originParams[item].match(/( |,|\n)/gi) : null
    if (originParams[item]) {
      if (match && match.length) {
        params[item] = originParams[item].split(match[0])
      } else if (!(originParams[item] instanceof Array)) {
        params[item] = [originParams[item]]
      } else {
        params[item] = originParams[item]
      }
    } else {
      params[item] = []
    }
  })
  return params
}

export function getRandomColor() {
	//十六进制颜色随机
	let r = Math.floor(Math.random() * 256);
	let g = Math.floor(Math.random() * 256);
	let b = Math.floor(Math.random() * 256);
	let color = "#" + r.toString(16) + g.toString(16) + b.toString(16);
	return color;
}

export function checkAndGetDomain(url) {
	if (!url || window.location.host.includes(".uat.")) {
		return url
	} else {
		if(url.includes('logic')) {
			return 'https://tscm-logic.trendygroup-it.com'
		} else if(url.includes('cost')) {
			return 'https://tscm-cost.trendygroup-it.com'
		} else if(url.includes('data')) {
			return 'https://tscm-data.trendygroup-it.com'
		} else if(url.includes('user')) {
			return 'https://tscm-user.trendygroup-it.com'
		} else {
			return ''
		}
	}
}
export function qcDownload(params) {
	axios.post(conf.QC_SCHELING_CHECKLIST_EXPORT, params, {
		headers: {
			'AdminUserKey-Info': getCookie('AdminUserKey'),
			'AdminUserToken-Info': getCookie('AdminUserToken'),
			'Application-type': 'LC'
		},
		responseType: "blob"
	}).then(res => {
		fileDown({ file: res.data, fileName: 'QC行程排单', type: 'xlsx' });
	})
}
